import { TextField } from '@mui/material';
import type { TextFieldProps } from '@mui/material';
import { forwardRef } from 'react';

export interface MobileNumberFieldProps extends Omit<TextFieldProps, 'type'> {
  /** Max digits accepted. Defaults to 10 (Indian mobile number length). */
  maxLength?: number;
}

/**
 * Drop-in replacement for <TextField type="tel"> for strict digits-only
 * numbers (mobile/phone). type="tel" is keyboard-hint only — the browser
 * does no character filtering, so it happily accepts letters. This strips
 * any non-digit character as the user types or pastes instead.
 */
export const MobileNumberField = forwardRef<HTMLDivElement, MobileNumberFieldProps>(
  function MobileNumberField({ maxLength = 10, onChange, slotProps, ...rest }, ref) {
    const passedInput =
      typeof slotProps?.htmlInput !== 'function' ? slotProps?.htmlInput : undefined;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      e.target.value = e.target.value.replace(/\D/g, '').slice(0, maxLength);
      onChange?.(e);
    };

    return (
      <TextField
        ref={ref}
        {...rest}
        type="tel"
        onChange={handleChange}
        slotProps={{
          ...slotProps,
          htmlInput: {
            ...passedInput,
            maxLength,
            inputMode: 'numeric',
          },
        }}
      />
    );
  },
);
